export type NotificationAge =
  | { unit: "now" }
  | { unit: "minute" | "hour" | "day"; count: number }

const minuteMs = 60_000
const hourMs = 60 * minuteMs
const dayMs = 24 * hourMs

export function notificationAge(createdAt: Date, now: Date): NotificationAge {
  const elapsedMs = now.getTime() - createdAt.getTime()
  if (!Number.isFinite(elapsedMs) || elapsedMs < minuteMs)
    return { unit: "now" }

  const minutes = Math.floor(elapsedMs / minuteMs)
  if (minutes < 60) return { unit: "minute", count: minutes }

  const hours = Math.floor(elapsedMs / hourMs)
  if (hours < 24) return { unit: "hour", count: hours }

  return { unit: "day", count: Math.floor(elapsedMs / dayMs) }
}

export function isNotificationFromToday(createdAt: Date, now: Date): boolean {
  return (
    createdAt.getFullYear() === now.getFullYear() &&
    createdAt.getMonth() === now.getMonth() &&
    createdAt.getDate() === now.getDate()
  )
}
